import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionZincCombined from "./index";

const NutritionZincWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionZincCombined}
    keyControlsId="nutrition-zinc-key"
    {...props}
  />
);

export default NutritionZincWithToggleKey;
